
import { computed, defineComponent } from 'vue';

import CheckBox from '@/components/CheckBox.vue';
import { useCalculationState } from '@/lib/calculationstate';
import params from '@/lib/calculationparams';
import InsuranceInfo from './InsuranceInfo.vue';

export default defineComponent({
  name: 'InsuranceBar',
  components: {
    InsuranceInfo,
    CheckBox,
  },
  setup() {
    const state = useCalculationState();
    const exceedsUwvMax = computed(() => state.salary > params.uwv.maximumSalary);
    const exceedsExcedentMax = computed(() => state.salary > params.nvschade.excedentMaximum);

    return {
      state,
      exceedsUwvMax,
      exceedsExcedentMax,
    };
  },
});
